export class ContactModel {
    contactId: number = 0;
    clientId: number | null = null;
    constructionSiteId: number | null = null;
    providerId: number | null = null;
    typeContact: number = 0;
    name: string = "";
    position: string | null = null;
    phone: string = "";
    phone2: string = "";
    email: string | null = null;
    isContact: boolean = true;
    createDate: string = "";
    userNameCreate: string = "";
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}